import { FieldValues } from 'react-hook-form'

import {
  TAppealFormImages,
  TEditAppealProduct,
  TEditAppealProductParameter,
} from '../type'
type TprepareEditProductParamsArray = {
  data: FieldValues
  allImagesList: [] | TAppealFormImages[]
  productId: number
}

// приведение редактируемого товара к нужному виду
export const prepareEditableProductObject = ({
  data,
  allImagesList,
  productId,
}: TprepareEditProductParamsArray): TEditAppealProduct => {
  const newParametersArray: TEditAppealProductParameter[] = Object.entries(data)
    .map(([idValue, value]) => ({
      id: Number(idValue),
      parameterValue: { value: value as string | boolean | number | null },
    }))
    .filter(
      item =>
        item.parameterValue.value !== null && item.parameterValue.value !== '',
    )

  const imagesParameters = allImagesList.map(image => ({
    id: +image.paramId,
    parameterValue: { value: image.serverUid },
  }))

  const editableProduct: TEditAppealProduct = {
    id: productId,
    parameters: [...newParametersArray, ...imagesParameters],
  }

  return editableProduct
}
